import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { HeaderTemplateData } from '../dialog-data.interface';

export interface DialogData {
    header: HeaderTemplateData;
    content: any;
}
@Component({
    selector: 'app-remark-dialog',
    templateUrl: './remark-dialog.html',
})
export class RemarkDialogComponent {
    header:HeaderTemplateData;
    content:any;
    constructor(
        public dialogRef: MatDialogRef<RemarkDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: DialogData,
    ) {
        if(data){
            this.header = data.header;
            this.content = data.content;
        }
    }

}
